import { useAuth } from "react-oidc-context";
import { Outlet, type RouteObject, createBrowserRouter } from "react-router-dom";
import { useConfigContext } from "@imminently/react/context/config";

import { AppLayout } from "@/components/AppLayout";
import {
  Auth,
  Error as ErrorPage,
  Home,
  Landing,
  Unauthorized,
  patientLoader,
} from "@/pages";
import { FallbackError } from "@/pages/error";
import { LoadEncounter, findEncounterLoader } from "@/pages/load-encounter";
import { SearchPage } from "@/pages/search";
import App from "./App";
import { useLiveEncounters } from "@/services";
import { AppLoading } from "@/pages/app-loading";
import { AwaitPatient } from "@/pages/patient/patient";
import { settingRoutes } from "@/pages/settings";
import { ClinicalLayout } from "@/components/ClinicalLayout";
import { WORK_OFFLINE } from "@/resources/constants";

const Authenticated = () => {
  const auth = useAuth();
  const config = useConfigContext();

  console.log("[Authenticated] user expiry", {
    authenticated: auth.isAuthenticated,
    expired: auth.user?.expired,
    expires_at: auth.user?.expires_at,
    expires_in: auth.user?.expires_in,
  });

  if (WORK_OFFLINE || config.auth.type === "none" || auth.isAuthenticated) {
    return <Outlet />;
  }

  if (!auth.isLoading && (!auth.user || auth.user?.expired)) {
    auth.signinRedirect();
  }

  return <AppLoading />;
};

const LiveEncounters = () => {
  useLiveEncounters();
  return <Outlet />;
};

const routes: RouteObject[] = [
  {
    path: "/",
    element: <App />,
    errorElement: <FallbackError />,
    children: [
      {
        index: true,
        element: <Landing />,
      },
      {
        path: "authcallback",
        element: <Auth />,
      },
      {
        path: "unauthorized",
        element: <Unauthorized />,
      },
      {
        path: "error",
        element: <ErrorPage />,
      },
      {
        element: <Authenticated />,
        children: [
          {
            element: <AppLayout />,
            children: [
              {
                element: <ClinicalLayout />,
                children: [
                  {
                    path: "patients",
                    children: [
                      {
                        element: <LiveEncounters />,
                        children: [
                          {
                            index: true,
                            element: <Home />,
                          },
                          {
                            path: ":id",
                            children: [
                              {
                                index: true,
                                element: <AwaitPatient />,
                                loader: patientLoader,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  // { path: "users", element: <Accounts /> },
                  {
                    path: "load-encounter/:id",
                    element: <LoadEncounter />,
                    loader: findEncounterLoader,
                  },
                  {
                    path: "search",
                    element: <SearchPage />,
                    // loader: searchPageLoader,
                  },
                ],
              },
              settingRoutes,
            ],
          },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
